<template>
  <div class="new-house">
    <div class="search-section">
      <headlines-search @headlinesSearch="headSearch"></headlines-search>
    </div>
    <div class="headline-section">
      <div class="headline-wrap">
        <div class="type-list">
          <div class="type" :class="{active: active === i}" v-for="(item, i) in headLineDictList" :key="i" @click="changeType(item, i)">{{ item.label }}</div>
        </div>
        <div v-if="headlineObj.list && headlineObj.list.length > 0" class="article-list">
          <headLineCom v-for="(item, i) in headlineObj.list" :showBorder="i !== headlineObj.list.length - 1" :key="i" :content="item" />
        </div>
        <div v-else class="item-empty-headline">
          <img alt="暂时还没有头条" src="https://xfjoss.coli688.com/pc-images/palceholder.png"/>
          <div class="item-empty-title">暂时还没有头条</div>
        </div>
        <el-pagination
          v-if="headlineObj.list && headlineObj.list.length > 0"
          class="head-line-pagination"
          background
          :pageSize="10"
          layout="prev, pager, next"
          :total="headlineObj.total"
          @current-change="currentChange"
          :currentPage.sync="headlineObj.current"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import HeadlinesSearch from "@/components/HeadlinesSearch.vue"
import headLineCom from './headLineCom.vue'
import { mapGetters } from 'vuex'
import swTracker from '@/mixins/tracker.js'

export default {
  name: "HeadLine",
  mixins: [swTracker],
  components: {
    HeadlinesSearch,
    headLineCom,
  },
  data () {
    return {
      headLineDictList: [],
      headlineDictId: -1,
      active: 0,
      headlineObj: [],
      headlineObjList: []
    }
  },
  computed: {
    ...mapGetters(['homePage'])
  },
  watch: {
    'homePage.id' () {
      this.getHeadLineDictList()
      this.getHeadLineList()
    },
    '$route.query.searchValue' (val) {
      this.headlineObjList = []
      if (val !== '' && val !== undefined) {
        this.headlineObj.list.forEach((item) => {
          if(item.title.indexOf(val) !== -1) {
            this.headlineObjList.push(item)
          }
        })
      }else {
        this.getHeadLineList(1)
      }
      this.headlineObj.list = this.headlineObjList
    }
  },
  created () {
    this.getHeadLineDictList()
    this.getHeadLineList()
  },
  methods: {
    headSearch (val) {
      if(val === this.$route.query.searchValue) {
        this.headlineObjList = []
        if (val !== '' && val !== undefined) {
          this.headlineObj.list.forEach((item) => {
            if(item.title.indexOf(val) !== -1) {
              this.headlineObjList.push(item)
            }
          })
          }else {
            this.getHeadLineList(1)
          }
          this.headlineObj.list = this.headlineObjList
        }
    },
    changeType (item, i) {
      this.active = i
      this.headlineDictId = item.value
      this.getHeadLineList(1)
    },
    // 获取楼盘头条分类
    async getHeadLineDictList (){
      const params = {
        code: 'headline_type',
        visibleRoleType: 1,
        homePageId: this.homePage.id
      }
      const res = await this.$api.getHeadLineDictList(params)
      let headLineDictList = []
      if (res.code === 200) {
        headLineDictList = res.data || []
        headLineDictList = headLineDictList.map((item) => {
          return {
            label: item.name,
            value: item.id,
          }
        })
      }
      headLineDictList.unshift({ label:'全部', value: -1 })
      this.headLineDictList = headLineDictList
    },
    getHeadLineList (page) {
      const headlineDictId = this.headlineDictId

      let params = {
        visibleRoleType: 1,
        headlineDictId: headlineDictId === -1 ? null : headlineDictId,
        page: page || 1,
        limit: 10,
        homePageId: this.homePage.id
      }
      this.$api.getHeadLineList(params).then(res => {
        if (res.code === 200) {
          this.headlineObj = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    currentChange (val) {
      this.getHeadLineList(val)
    }
  }
};
</script>
<style lang="scss" scoped>
.new-house{
  width: 100vw;
  background: #F5F5F6;
  .search-section{
    width: 1180px;
    margin: 0 auto;
    padding: 35px 0px 35px 0px;
  }
  .headline-section{
    background: white;
    .headline-wrap{
      width: 1180px;
      margin: 0 auto;
      overflow: hidden;
      .type-list{
        width: 100%;
        height: 54px;
        border-bottom: 1px solid #BDA26C;
        margin-top: 24px;
        .type{
          display: inline-block;
          @include font16(450, rgba(51, 51, 51, 1));
          font-family: PingFangSC-Regular;
          line-height: 54px;
          padding: 0 16px;
          cursor: pointer;
          &:hover{
            color: rgba(189, 162, 108,1);
          }
        }
        .active{
          background: #BDA26C;
          color: white;
          &:hover{
            color: rgba(255, 255, 255,1);
          }
        }
      }
      .item-empty-headline {
        text-align: center;
        margin:20% auto;
        transform: translateY(-50%);
        .item-empty-title {
          color: rgba(180, 169, 149, 1);
          font-size: 14px;
          font-family: MicrosoftYaHeiSemilight;
          margin-top: 20px;
        }
      }
    }
  }
  .head-line-pagination{
    float: right;
    margin: 35px 0 120px;
  }
}
</style>
<style lang="scss">
  .head-line-pagination .el-pager{
    .active{
      background-color: #BDA26C!important;
    }
  }
</style>
